import React, { useEffect, createContext, useContext } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
const AuthContext = createContext();

export const RequireAuth = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const authLoading = useSelector((state) => state.auth.loading);
  const [isRehydrated, setIsRehydrated] = React.useState(false);

  useEffect(() => {
    // Give redux-persist time to rehydrate
    const timer = setTimeout(() => {
      setIsRehydrated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Don't check authentication until rehydrated and not loading
    if (isRehydrated && !authLoading) {
      checkAuthentication();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, authLoading, isRehydrated, location, params]);

  const checkAuthentication = () => {
    if (!authenticated) {
      navigate("/login");
    } else {
      return true;
    }
  };

  // Show nothing while loading auth state or rehydrating
  if (!isRehydrated || authLoading) {
    return null;
  }

  return authenticated ? children : null;
};

export const useAuth = () => {
  return useContext(AuthContext);
}
